import marked from 'marked';
import parser from 'html-react-parser';

const markdownToReact = (content: string) => {
  return parser(marked(content));
};

export default markdownToReact;
